import TextService from './TextService'

export default TextService
